<template>
    <a-modal
      title="退款"
      :width="600"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      :closable="false"
      :maskClosable="false"
    >
              <a-form :form="form" >
            <p style="text-align: center;font-size: 20px;font-weight: bold">{{txt.enterpriseName}}</p>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市场负责人">
             {{txt.marketPrincipal}}
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业余额">
              {{txt.totalBalance}}
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="退款金额">
              <a-input  v-decorator="['refundMoney']"  />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="余额">
              <a-input   v-model=txt.totalBalance disabled="true" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-textarea
                v-decorator="['remark']"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
      </a-form>
    </a-modal>
</template>

<script>
  import { refundinsert } from '@/api/enterprise/enterpriseAccount'
    export default {
        name: "Accountrefund",
      data(){
          return{
            form:this.$form.createForm(this),
            visible:false,
            confirmLoading:false,
            txt:{},
            labelCol: {
              xs: { span: 24 },
              sm: { span: 5 }
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 12 }
            },
          }
      },
      methods:{
        handleSubmit(){
          this.form.validateFields((err, values) => {
            console.log(values)
            values.enterpriseId=this.txt.enterpriseId

            refundinsert(values).then(res=>{
              if(res.code==0){
                  this.$message.success('退款成功')
                  this.$emit('ok')
                  this.visible=false
              }else{
                this.$message.success('退款失败')
              }
            })
          })
        },
        add(value){
          this.form.resetFields()
          this.txt=value
          this.visible=true
        }
      }
    }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>